// פונקציה שמקבלת כתובת ומחזירה קואורדינטות (lat/lng) באמצעות Nominatim
export async function getLatLngFromAddress({ city, neighborhood, country }) {
  const address = [neighborhood, city, country].filter(Boolean).join(', ');
  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;
  const response = await fetch(url, {
    headers: {
      'Accept-Language': 'en',
      'User-Agent': 'ShabbatAbroad/1.0 (your@email.com)'
    }
  });
  const data = await response.json();
  if (data && data.length > 0) {
    return {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon)
    };
  }
  return null;
} 